import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import { OutboundLink } from 'gatsby-plugin-gtag';
import YoutubeVideo from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/YoutubeVideoCardUpdate';
import PrimaryBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/720p_Cameras/PrimaryBox';
import NavButtons from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/NavButtons';
import ForumBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  OutboundLink,
  YoutubeVideo,
  PrimaryBox,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};